module.exports = __webpack_public_path__ + "img/CM-SL-CA-Honda-Established.7e844fce.jpeg";